import "@wangeditor/editor/dist/css/style.css"; // 引入 css

import React, { useState, useEffect } from "react";
import { Editor, Toolbar } from "@wangeditor/editor-for-react";

import { DomEditor } from "@wangeditor/editor";
import handleFileInCompressUploading from "../../utils/cos_compress";
import { getBase64 } from "../../utils/getbase64";
import { message } from "antd";
import handleFileInUploading from "../../utils/cos";

function RichTextEditor({ defaultContent, deliveryRichtext }) {
  // editor 实例
  const [editor, setEditor] = useState(null);
  // 编辑器内容
  const [html, setHtml] = useState("");

  // 模拟 ajax 请求，异步设置 html
  useEffect(() => {
    setTimeout(() => {
      setHtml(defaultContent);
    }, 100);
  }, []);

  useEffect(() => {
    //要先初始化实例才能进行设置
    if (editor) {
      const toolbar = DomEditor.getToolbar(editor);
      const curToolbarConfig = toolbar.getConfig();
      // 当前菜单排序和分组
      console.log(curToolbarConfig);
      // console.log(editor);
      // console.log(editor.getAllMenuKeys());
    }
  }, [editor]);

  // 工具栏配置
  const toolbarConfig = {
    toolbar: ["image"],
    excludeKeys: ["fontFamily", "insertLink", "insertTable", "todo"],
  };

  const uploadImage = {
    async customUpload(file, insertFn) {
      let res = {};
      const afterUpload = async (origin, thumbnail, file) => {
        const aporigin =
          "https://" +
          origin.replace("cos.accelerate", "cos-website.ap-shanghai");
        const apthumbnail =
          "https://" +
          thumbnail.replace("cos.accelerate", "cos-website.ap-shanghai");
        res = {
          origin: aporigin,
          thumbnail: apthumbnail,
        };
        //插入图片
        insertFn(res.origin, "image", res.thumbnail);
      };
      handleFileInCompressUploading(file, afterUpload);
    },
  };

  const uploadVideo = {
    async customUpload(file, insertFn) {
      //做类型校验
      console.log(file.type);
      const isVideo = file.type === "video/mp4" || file.type === "image/avi";
      if (!isVideo) {
        message.error("只能上传mp4或avi文件!");
        return false;
      }
      const afterUpload = (url) => {
        const video =
          "https://" + url.replace("cos.accelerate", "cos-website.ap-shanghai");
        console.log(video);
        if ((url ?? false) && url !== "") {
          message.success("视频上传成功！");
          insertFn(video, "");
        }
        // console.log(url);
      };
      handleFileInUploading(file, afterUpload);
    },
  };

  // 编辑器配置
  const editorConfig = {
    placeholder: "请输入内容...",
    MENU_CONF: {
      uploadImage: uploadImage,
      uploadVideo: uploadVideo,
    },
  };

  const handleChange = (editor) => {
    setHtml(editor.getHtml());
    console.log(editor.getHtml());
    deliveryRichtext(editor.getHtml());
  };

  // 及时销毁 editor ，重要！
  useEffect(() => {
    return () => {
      if (editor == null) return;
      editor.destroy();
      setEditor(null);
    };
  }, [editor]);

  return (
    <>
      <div style={{ border: "1px solid #ccc", zIndex: 100, width: "60vw" }}>
        <Toolbar
          editor={editor}
          defaultConfig={toolbarConfig}
          mode="default"
          style={{ borderBottom: "1px solid #ccc" }}
        />
        <Editor
          defaultConfig={editorConfig}
          value={html}
          onCreated={setEditor}
          onChange={handleChange}
          mode="default"
          style={{ height: "500px", overflowY: "hidden",textAlign:'left' }}
        />
      </div>
      {/* <div style={{ marginTop: "15px" }}>{html}</div> */}
    </>
  );
}

export default RichTextEditor;
